import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { StorageService } from "../services/storage.service";
import { navigateHome } from "../utils/home-route.util";
import { MyZpaxService } from "src/app/services/myzpax.service";
import { AccessDeniedQueryParam, AccessDeniedReason } from "src/app/features/access-denied/access-denied.constants";

/**
 * Fallback routes (e.g. /marketing) are where SSO lands users who do NOT have
 * access to Rehab Connect, so there should never be an active session here.
 * If a session exists, the user must not remain on the fallback route — redirect
 * them into the app and let the existing guards/interceptor enforce validity.
 */
export const fallbackRouteGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const myzpaxService = inject(MyZpaxService);

  if (storageService.hasActiveSession()) {
    navigateHome(router, true);
    return false;
  }

  // /marketing is a myzPAX-tile sales pitch: it only makes sense embedded in
  // myzPAX, where "Learn More" can postMessage the parent frame. Reached as a
  // standalone tab (e.g. rehabconnect.com opened directly), it's SSO telling
  // us this account has no RC access — show that instead of a pitch for a
  // product the user thinks they already have.
  if (!myzpaxService.isInMyzpax) {
    return router.createUrlTree(["/access-denied"], {
      queryParams: { [AccessDeniedQueryParam.reason]: AccessDeniedReason.Sso },
    });
  }

  return true;
};
